module.exports = __webpack_public_path__ + "static/media/sdasd.461dbf0e.png";